import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-button',
    template: `
    <!-- <input type="radio" [ngClass]="to.style" [checked]="to.isChecked" [name]="to.fieldName"/> -->

    <div [ngClass]="to.divStyle">
		<span [ngClass]="to.numberingStyle">{{to.number}}</span>
		<!-- <label for="fordLayout1" class="flayout1">				
        </label> -->
        <img [src]="to.imgSrc" [ngClass]="to.imgStyle">
		<br>
        <span [ngClass]="to.textStyle" *ngIf="to.text!==''">{{to.text}}</span>
        <span [ngClass]="to.textStyle" *ngIf="to.text===''">&nbsp;</span>
		<input type="radio" [ngClass]="to.style" [checked]="to.isChecked" [name]="to.fieldName" [value]="to.fieldValue" />			
	</div>
 `,
})
export class FormlyFieldRadio extends FieldType {

}